export { default } from './AppNotification';



// WEBPACK FOOTER //
// ./src/components/atoms/AppNotification/index.js